export const QUICK_STEPS_SETTING_NAME = 'mail_quicksteps';
export const CURRENT_QUICKSTEP_VERSION = 6;
// Version 1, adding pin, unpin, ignore, snooze
// Version 2, adding create task, reply with meeting
// Version 3, adding always ask for folder when running Quick Step
// Version 4, adding always ask for category when running Quick Step
// Version 5, adding copilot reply with meeting Quick Step
// Version 6, adding reply with template, reply all with template, and forward with template Quick Steps
